__turbopack_context__.v({
  "catalogue": "UxoGda_catalogue",
  "catalogueContent": "UxoGda_catalogueContent",
  "multipleLink": "UxoGda_multipleLink",
  "titleBox": "UxoGda_titleBox",
});
